import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53eb9ab9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card post-card" }
const _hoisted_2 = {
  class: "bg-image hover-overlay ripple",
  "data-mdb-ripple-color": "light"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mask",
  style: {"background-color":"rgba(251, 251, 251, 0.15)"}
}, null, -1))
const _hoisted_5 = { class: "card-body post-card-body" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "card-title post-card-title" }, " What is LinkedIn Scraping? Challenges and 4 Use Cases ", -1))
const _hoisted_7 = { class: "post-card-subtitle mx-4" }
const _hoisted_8 = { class: "mb-2 my-3 postcard-author" }
const _hoisted_9 = { href: "#" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_11 = {
  class: "mb-2 my-3 postcard-calender",
  style: {"font-weight":"300"}
}
const _hoisted_12 = {
  href: "#",
  style: {"font-weight":"300"}
}
const _hoisted_13 = {
  class: "mb-2 my-3 postcard-comments",
  style: {"font-weight":"300"}
}
const _hoisted_14 = {
  href: "#",
  disabled: "",
  style: {"font-weight":"300"}
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card-text postcard-body-text" }, " LinkedIn scraping is an automation strategy to scrape publicly available data on LinkedIn for lead generation. LinkedIn is the largest social network for professionals to connect, share, and learn. LinkedIn is continuously growing with 830 million members worldwide. LinkedIn empowered 1.2 million job seekers to grow in their careers and expand their professional network through […] ", -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Read")


import {
  BIconPerson,
  BIconCalendarEvent,
  BIconChatLeft,
} from 'bootstrap-icons-vue';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  props: {
  cover: String,
},
  setup(__props) {

const props = __props

const date = moment().format('MMMM Do YYYY');



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: props.cover,
        class: "img-fluid"
      }, null, 8, _hoisted_3),
      _createVNode(_component_router_link, { to: "/blog/posts/linkedin-scraping" }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_link, { to: "/blog/posts/linkedin-scraping" }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h6", _hoisted_8, [
          _createVNode(_unref(BIconPerson)),
          _createElementVNode("a", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", null, _toDisplayString('By: proxyscrape'.toUpperCase()), 1)
          ])
        ]),
        _createElementVNode("h6", _hoisted_11, [
          _createVNode(_unref(BIconCalendarEvent)),
          _createElementVNode("a", _hoisted_12, [
            _createElementVNode("span", null, "  " + _toDisplayString(_unref(date).toUpperCase()), 1)
          ])
        ]),
        _createElementVNode("h6", _hoisted_13, [
          _createVNode(_unref(BIconChatLeft)),
          _createElementVNode("a", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("span", null, _toDisplayString('Comments off'.toUpperCase()), 1)
          ])
        ])
      ]),
      _hoisted_16,
      _createVNode(_component_router_link, {
        to: "/blog/posts/linkedin-scraping",
        class: "btn-primary btn-sm"
      }, {
        default: _withCtx(() => [
          _hoisted_17
        ]),
        _: 1
      })
    ])
  ]))
}
}

})